module.exports = __webpack_public_path__ + "static/media/2-removebg-preview.69c1704b.png";